// @flow

/**
 * Module dependencies.
 */

import { colors } from 'client/styles';
import { position } from 'polished';
import styled from 'styled-components';

/**
 * Export `Overlay` component.
 */

export default styled.div`
  background-color: ${colors.shadesOfBlue.bigStoneDarker};
  opacity: 0.9;

  ${position('absolute', '0', '0', '0', '0')};
`;



// WEBPACK FOOTER //
// ../src/client/components/header/overlay.js